var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.58793 1L1 1.58793L15.4121 16L16 15.4121L1.58793 1Z",
    fill: "#003B6F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4121 1L1 15.4121L1.58793 16L16 1.58793L15.4121 1Z",
    fill: "#003B6F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.58793 1L1 1.58793L15.4121 16L16 15.4121L1.58793 1Z",
    stroke: "#003B6F",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4121 1L1 15.4121L1.58793 16L16 1.58793L15.4121 1Z",
    stroke: "#003B6F",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close-icon.47ce8d60d7f3f10f4849494ab7733bb4.svg";
export { ForwardRef as ReactComponent };